export type ParentWebsite = 'west-midlands' | 'coventry';
